import { Icon } from "@chakra-ui/react/icon";
import React from "react";

interface FooterIconProps {
  w?: number;
  h?: number;
  fill?: string;
  children?: React.ReactNode;
}

const FooterIcon = ({ w = 8, h = 8, fill, children }: FooterIconProps) => {
  return (
    <Icon w={w} h={h} color={fill || "white"}>
      {children}
    </Icon>
  );
};

export default FooterIcon;
